import { withRouter } from 'react-router-dom';
import { min } from 'ramda';
import { compose, defaultProps, withHandlers, withProps, withState } from 'recompose';
import { withViewportMeta } from '../HOCs/withViewportMeta';
import { handleBackAction } from '../utils/history';
import { theme } from '../theme';
import { withTheme } from '../utils/styling/styled-components';
var enhance = compose(withTheme, withRouter, defaultProps({
  collapse: false,
  disableResponsiveSticky: false,
  maxWidth: 1200,
  preventDefault: false,
  showBack: true,
  showInverted: false,
  showResponsiveTitle: true,
  hasStickySettings: false
}), withState('scrollPercent', 'setScrollPercent', 0), withHandlers({
  onBackPress: function onBackPress(props) {
    return function () {
      if (!props.preventDefault) {
        handleBackAction(props);
      }

      if (props.onBack) {
        props.onBack();
      }
    };
  },
  onSettingsPress: function onSettingsPress(props) {
    return function () {
      if (!props.settingsPath) {
        return props.history.push('/settings');
      }

      return props.history.push(props.settingsPath);
    };
  }
}), withProps(function (_ref) {
  var location = _ref.location;
  return {
    depth: location.pathname.split('/').length - 1
  };
}), withProps(function (_ref2) {
  var depth = _ref2.depth;
  return {
    hasBack: depth >= 1
  };
}), withViewportMeta, withProps(function (_ref3) {
  var disableResponsiveSticky = _ref3.disableResponsiveSticky,
      pageWidth = _ref3.pageWidth,
      scrollTop = _ref3.scrollTop;
  var desktop = pageWidth > theme.breakpoints.md;
  return {
    scrollPercent: min(scrollTop, 35) / 35,
    sticky: desktop || !disableResponsiveSticky && scrollTop > 400,
    stickyHeight: desktop ? 60 : 56
  };
}));
export { enhance };